import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const getSpecificVANData = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`van/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSpecificVANData;
